/* Publish by EComposer at 2026-10-20 05:12:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q4xzyyvxxs"]=  window.__ectimmers["ecom-q4xzyyvxxs"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-q4xzyyvxxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4xzyyvxxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-el2ou0copdk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-el2ou0copdk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8a630h6mfco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8a630h6mfco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fuzoabn2ezf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fuzoabn2ezf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x7d5yuli3vi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x7d5yuli3vi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hkfk447aw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hkfk447aw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8eka76cw56j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8eka76cw56j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwegzmsowm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwegzmsowm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mden56crcgr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mden56crcgr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cvkt47bmkqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cvkt47bmkqq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2wdaeq0i2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2wdaeq0i2w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qowx6dk87o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qowx6dk87o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i1z3ta67q39').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i1z3ta67q39', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f846ekuz9z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f846ekuz9z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gcrimdxxnpe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gcrimdxxnpe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mib1nnt9rcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mib1nnt9rcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0utmwrhlesnb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0utmwrhlesnb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2k3ojttktnq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2k3ojttktnq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6d3dk37x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6d3dk37x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5w2iob3yzm5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5w2iob3yzm5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-547bxsp2ywu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-547bxsp2ywu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vza6fzoyw0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vza6fzoyw0g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-koj30ra13yc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-koj30ra13yc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6echm6acpe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6echm6acpe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vhxu5ioqsu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vhxu5ioqsu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spu68s0bwhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spu68s0bwhi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3fbp3ivvrnw"]=  window.__ectimmers["ecom-3fbp3ivvrnw"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-3fbp3ivvrnw"]["mxlmfq2dt"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-3fbp3ivvrnw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fbp3ivvrnw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7hyohew51').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7hyohew51', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3snuwqsxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3snuwqsxc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9v03i4n38uu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9v03i4n38uu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-042574otk3fj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-042574otk3fj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8tnn1fbw6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8tnn1fbw6d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bntbmshuhda').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bntbmshuhda', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-421jbpelkyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-421jbpelkyf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qklgbqo1ase').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qklgbqo1ase', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fx3tsfsswkm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fx3tsfsswkm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-535c26bj99k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-535c26bj99k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kw1db40iib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kw1db40iib', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9noq7889oc5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9noq7889oc5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0s7z0k0psmw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0s7z0k0psmw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spszsergj5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spszsergj5s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ux1rk0anz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ux1rk0anz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsklznb5hhm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsklznb5hhm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dc50r53ppc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dc50r53ppc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sp5u674ctn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sp5u674ctn9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g62k3zotytm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g62k3zotytm', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qro01phy8p"]=  window.__ectimmers["ecom-qro01phy8p"] || {};
const t=this.$el;if(!t)return;let e=this.isLive,i=t.querySelector(".ecom-masonry-layout");if(!i)return;if(this.settings.lightbox){let a=this.$el.querySelectorAll("[ecom-modal]");a.forEach(d=>{let p=d.closest("a[href]");p&&p.addEventListener("click",function(m){e||m.preventDefault(),m.stopPropagation()},!0)});const l=function(d){if(window.EComModal)return d();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&d()});return}let p=0;const m= window.__ectimmers["ecom-qro01phy8p"]["7oclgzb1q"] = setInterval(function(){window.EComModal?(clearInterval(m),d()):++p>=300&&clearInterval(m)},50)},c=()=>{a.length&&window.EComModal&&new window.EComModal(a,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})};a.length&&l(c)}i.addEventListener("itemChange",function(){setTimeout(function(){i.masonry.layout()},500)});var o=i.getAttribute("data-ecom-packery-params")||"{}";let n=Object.assign({itemSelector:".ecom-masonry-layout__item",layoutMode:"masonry",percentPosition:!0,resize:!0},JSON.parse(o));var r=new window.EComPackery(i,n);i.masonry=r,i.querySelectorAll("img").forEach(function(a){a.addEventListener("load",function(){r.layout()})})

                    });
                    
                        document.querySelectorAll('.ecom-qro01phy8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qro01phy8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bnp9tl71lhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bnp9tl71lhi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i9lugbu0he').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i9lugbu0he', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vt7cysnurfs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vt7cysnurfs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcmwubvh4od').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcmwubvh4od', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b1ql16umgtr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b1ql16umgtr', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gwe1cega9ws"]=  window.__ectimmers["ecom-gwe1cega9ws"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-gwe1cega9ws"]["agkos2yyv"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-gwe1cega9ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gwe1cega9ws', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9246zrwoglw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9246zrwoglw', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lu3usyjo8hl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lu3usyjo8hl', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8eozjhto5vf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8eozjhto5vf', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nfgyu1tv4qi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nfgyu1tv4qi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bna3tmpg7hn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bna3tmpg7hn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbitbg97qxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbitbg97qxq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-byva20ordk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-byva20ordk9', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9kll0vooml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9kll0vooml', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o99ri90tbhk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o99ri90tbhk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kr57uv1ubj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kr57uv1ubj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8ick7t2dhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8ick7t2dhs', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mxgztobl4xq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mxgztobl4xq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}